import { render, staticRenderFns } from "./MangelDetails.vue?vue&type=template&id=27d8fe90"
import script from "./MangelDetails.vue?vue&type=script&lang=js"
export * from "./MangelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports